// import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _some from 'lodash/some';
import _keys from 'lodash/keys';
import _isArray from 'lodash/isArray';
import _omit from 'lodash/omit';

// Check if the query is empty
export const isQueryEmpty = query => {
    const keys = _keys(query);
    return !_some(keys, key => {
        const field = query[key];
        if (_isArray(field)) {
            return field.length > 0;
        } else {
            return !!field;
        }
    });
};

// Check if there's any non-location filters in the query
export const isNonLocationFiltersExistsInQuery = query => {
    const pickedQuery = _pick(query, ['jobTitle', 'jobType', 'datePost', 'salaryRate', 'workFromHome', 'internPositions']);
    return !isQueryEmpty(pickedQuery);
};

// Get a new query object for Job Center
export const getNewJobCenterQuery = ({ prevQuery, newQuery, omit = [] } = {}) => {
    return _omit({ ...prevQuery, ...newQuery }, ['id', 'employerId', ...omit]);
};

// Get a new query object for Talent Center
export const getNewTalentCenterQuery = ({ prevQuery, newQuery, omit = [] } = {}) => {
    return _omit({ ...prevQuery, ...newQuery }, ['id', 'userId', ...omit]);
};
